import CreditScore from '../cards/credit-score';
import { PrimaryBorrowerEmail } from '../cards/email';
import LoanType from '../cards/loan-type';
import PreviousPreapproval from '../cards/previous-preapproval';
import WelcomeCard from '../cards/welcome/full';
import { Card, End } from '../components/deck';
import { acceptedOfferCreditBranch } from './branches/accepted-offer-credit';
import Coborrower from './branches/coborrower';
import Disqualifying from './branches/disqualifying';
import { DownPaymentEvaluationBranch } from './branches/down-payment-evaluation';
import Employment from './branches/employment';
import HasAgent from './branches/has-agent';
import OtherOfferBranch from './branches/other-offer';
import Ownership from './branches/ownership';
import Purchase from './branches/purchase';
import TimeToPurchaseNoOffer from './branches/time-to-purchase-no-offer';
import { VeteranStatusCompleted } from './branches/veteran-status-completed';

export default Card(
  WelcomeCard,
  Purchase(
    VeteranStatusCompleted(
      DownPaymentEvaluationBranch(
        OtherOfferBranch(
          Card(
            LoanType,
            Card(
              PreviousPreapproval,
              Ownership(
                'borrower',
                Employment(
                  'borrower',
                  Card(
                    CreditScore,
                    Coborrower(
                      Disqualifying(
                        HasAgent(
                          TimeToPurchaseNoOffer(
                            acceptedOfferCreditBranch(Card(PrimaryBorrowerEmail(), End()))
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/decks/purchase.js